export type ChartBarSizing = {
  categoryGapRatio: number;
  barGapRatio: number;
};

export const chartBarSizing = {
  default: {
    categoryGapRatio: 0.5,
    barGapRatio: 0.5,
  },
  landing: {
    categoryGapRatio: 0.5,
    barGapRatio: 0.5,
  },
} as const satisfies Record<string, ChartBarSizing>;
